import { NavbarMenuItemType } from 'src/types'
import { create } from 'zustand'

interface mainStateType {
  user: any //to do fix this kur te na vij useri
  updateMainKeys: (league: Partial<NavbarMenuItemType>) => void
}

export const useMainState = create<mainStateType>()((set) => {
  return {
    //states
    user: {},
    //actions
    updateMainKeys: set,
  }
})
